module.exports = __webpack_public_path__ + "img/tijiaochenggongen.d17b1208.png";